<mat-card appearance="outlined" id="login-register-card">
  <mat-card-content>
    <nav mat-tab-nav-bar>
      @for (link of navLinks; track link) {
        <a
          mat-tab-link
          id="{{ link.id }}"
          [routerLink]="link.path"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          >
          {{ link.label }}
        </a>
      }
    </nav>
    @if ((bannerStatus$ | async)) {
      <mat-toolbar
        id="login-banner"
        color="{{ bannerColor$ | async }}"
        fxFlexFill
        >
        <span id="login-banner-message">
          {{ bannerMessage$ | async }}
        </span>
      </mat-toolbar>
    }
    <div id="login-form-container">
      <form
        novalidate
        id="login-form"
        [formGroup]="registrationForm"
        (ngSubmit)="submit()"
        >
        <mat-form-field>
          <input
            id="login-registration-email"
            matInput
            placeholder="Email"
            formControlName="email"
            required
            />
          @if (validate('email', 'required')) {
            <mat-error>
              Email is required
            </mat-error>
          }
          @if (
            validate('email', 'email') &&
            !validate('email', 'required')
            ) {
            <mat-error
              >
              Value must be a valid email
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <input
            id="invite-hash"
            matInput
            placeholder="Invite Code"
            formControlName="inviteHash"
            required
            />
          @if (validate('inviteHash', 'required')) {
            <mat-error>
              Invite code is required
            </mat-error>
          }
        </mat-form-field>
        <button
          id="registration-button"
          mat-raised-button
          color="primary"
          type="submit"
                    [disabled]="
                        registrationForm.untouched || !registrationForm.valid
                    "
          >
          Sign Up
        </button>
        @if ((showProgressBar$ | async)) {
          <mat-progress-bar
            mode="indeterminate"
          ></mat-progress-bar>
        }
      </form>
    </div>
    <mat-toolbar id="support-toolbar">
      <button id="support-link" mat-button (click)="goToSupportForm()" role="link">
        Contact Support
      </button>
    </mat-toolbar>
  </mat-card-content>
</mat-card>
